var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn" }, [
    !_vm.organization.id
      ? _c("div", [
          _c("p", [
            _vm._v(
              "organization not found, or you do not have access to this organization in the given Org/Group context."
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.organization.id
      ? _c(
          "div",
          { staticClass: "personPage" },
          [
            _c(
              "b-row",
              { staticClass: "mb-3", attrs: { "align-h": "between" } },
              [
                _c("b-col", { attrs: { cols: "auto" } }, [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v(_vm._s(_vm.organization.title))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small text-muted" }, [
                    _vm._v("Added " + _vm._s(_vm.getCreatedAt()))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "auto" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to:
                            "/admin/organizations/" +
                            _vm.organization.id +
                            "/edit"
                        }
                      },
                      [
                        _c("b-button", { staticClass: "mx-0" }, [
                          _vm._v("Edit")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { sm: "8" } }, [
                  _c(
                    "div",
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("strong", [_vm._v("Information")])]
                          ),
                          _vm._v(" "),
                          _c("b-card-body", [
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("ID")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [_vm._v(_vm._s(_vm.organization.id))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("Organization Name")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [_vm._v(_vm._s(_vm.organization.title))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("Street")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [
                                _vm._v(_vm._s(_vm.organization.mailingStreet))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("City")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [
                                _vm._v(_vm._s(_vm.organization.mailingCity))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("County / Parish")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [
                                _vm._v(_vm._s(_vm.organization.county))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("State")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [
                                _vm._v(
                                  _vm._s(
                                    _vm.organization.mailingStateAbbreviation
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pb-4" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "mb-0 text-muted text-uppercase font-weight-bold"
                                },
                                [_vm._v("Postal Code")]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("h4", [
                                _vm._v(
                                  _vm._s(_vm.organization.mailingPostalCode)
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.organizationTypes.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "pb-4" },
                                  [
                                    _c(
                                      "small",
                                      {
                                        staticClass:
                                          "mb-0 text-muted text-uppercase font-weight-bold"
                                      },
                                      [_vm._v("Organization Type")]
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _vm._l(_vm.organizationTypes, function(
                                      organization
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: organization,
                                          attrs: { flush: "" }
                                        },
                                        [
                                          _c("h4", [
                                            _vm._v(_vm._s(organization))
                                          ])
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { sm: "4" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c("OrganizationGroups", {
                              attrs: {
                                organizationId: _vm.orgId,
                                memberGroups: _vm.organization.memberGroups
                              }
                            }),
                            _vm._v(" "),
                            _c("OrganizationMembers", {
                              attrs: {
                                organizationId: _vm.orgId,
                                organizationName: _vm.organization.title
                              }
                            }),
                            _vm._v(" "),
                            _c("ProgramList", {
                              attrs: {
                                organizationId: _vm.orgId,
                                orgState:
                                  _vm.organization.mailingStateAbbreviation,
                                defaultProgram: _vm.organization.defaultProgram,
                                programs: _vm.organization.programs
                              }
                            }),
                            _vm._v(" "),
                            _c("LocationList", {
                              attrs: {
                                organizationId: _vm.orgId,
                                defaultLocation:
                                  _vm.organization.defaultLocation,
                                locations: _vm.organization.locations
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c(
                              "b-card",
                              { attrs: { "no-body": "" } },
                              [
                                _c("b-card-header", [
                                  _c("b", [_vm._v("Meta")])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-list-group",
                                  { attrs: { flush: "" } },
                                  [
                                    _c(
                                      "b-list-group-item",
                                      { staticClass: "small text-muted" },
                                      [
                                        _c("b", [_vm._v("Created At: ")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getCreatedAt()) +
                                            "\n                  "
                                        ),
                                        _vm._.isObject(
                                          _vm.organization.createdBy
                                        )
                                          ? _c("div", [
                                              _c("b", [_vm._v(" by: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._.get(
                                                      _vm.organization,
                                                      "createdBy.emailAddress",
                                                      ""
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group-item",
                                      { staticClass: "small text-muted" },
                                      [
                                        _c("b", [_vm._v("Last Updated: ")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getLastUpdateDate()) +
                                            "\n                  "
                                        ),
                                        _vm._.isObject(
                                          _vm.organization.updatedBy
                                        )
                                          ? _c("div", [
                                              _c("b", [_vm._v(" by: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._.get(
                                                      _vm.organization,
                                                      "updatedBy.emailAddress",
                                                      ""
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-738c85ca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-738c85ca","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/Organization.vue
// module id = 1892
// module chunks = 0